import { useEffect, useState } from "react";
import { Form } from "reactstrap";
import { APISD } from "../../../../../../../../config/apisd";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ModalTipeLegerUpdate(props) {
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const [form, setForm] = useState({ name_type: "" });

  useEffect(() => {
    setForm({ name_type: props?.nameTypeUpdate || "" });
  }, [props?.nameTypeUpdate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APISD.put(
        `/api/type-leger/${props.id}`,
        {
          name_type: form.name_type.trim(),
          user_id:
            localStorage.getItem("id_user") ||
            localStorage.getItem("user_id") ||
            "",
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });
        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-tipe-leger"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="modal-update-tipe-leger" className="sims-modal-title">
            Update Tipe Leger
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body">
          <div className="sims-form-group">
            <label className="sims-form-label" htmlFor="name_type_update">
              Nama Tipe Leger <span>*</span>
            </label>
            <input
              id="name_type_update"
              className="sims-form-input"
              autoFocus
              required
              autoComplete="off"
              type="text"
              name="name_type"
              onChange={handleChange}
              value={form.name_type}
              placeholder="Masukkan nama tipe leger"
              
            />
          </div>

        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Perbarui
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
